import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import NavView from '../component/NavView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import { getImgPath } from '../store/JSTool';
import * as APJHttp from '../store/APJHttp';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useNavigate } from "react-router-dom";
import NavViewMobile from '../mobile/component/NavViewMobile';
import PageIndexView from '../component/PageIndexView';

let cacheDic = {};
let totalCount = 0;
let currentIndex = 0; //从0开始

export default function NewsListPage() {

    let navId = 'news_list_page_nav';
    let pageId = 'news_list_page_div';
    let sectionIdAry = ['news_list_news'];

    const dispatch = useDispatch();
    const [dataAry, setDataAry] = React.useState([]);
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);
        pageIndexTap(currentIndex);
    }, []);

    function pageIndexTap(i) {
        currentIndex = i;
        if (cacheDic[i] == null) {
            APJHttp.getNewsList(i, 5, (res) => {
                cacheDic[i] = res.data;
                totalCount =  Math.floor((res.totalCount + 4) / 5);//总共多少页,从1开始
                setDataAry(res.data);
            }, (code, msg) => {
                dispatch(settingActions.showToast(`code ${code}: ${msg}`));
            })
        } else {
            setDataAry(cacheDic[i]);
        }
    }

    return (
        <Stack component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>

            {settingData.isMobile && <NavViewMobile navId={navId} pageId={pageId} />}
            {!settingData.isMobile && <NavView navId={navId} pageId={pageId} />}

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                    minHeight: '100vh',
                }} >

                <Stack sx={{
                    width: 1,
                    bgcolor: 'black'
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath('apj_banner.png')}
                        sx={{
                            opacity: 0.5,
                            width: 1,
                            maxHeight: settingData.isMobile ? '200px' : '300px',
                            minHeight: settingData.isMobile ? '100px' : '150px',
                            objectFit: 'cover',
                        }} />
                </Stack>

                <SectionView id={sectionIdAry[0]} title='News' />
                {
                    dataAry.map((item, index) => {
                        return <NewsItem key={index} item={item} />
                    })
                }

                {/* 分页 */}
                <PageIndexView totalCount={totalCount} pageIndexTap={pageIndexTap} currentIndex={currentIndex} />

                <Box sx={{ flex: 1 }} />
                <Box
                    id='apj_logo_id'
                    component={'img'}
                    src={getImgPath('logo_black.png')}
                    sx={{
                        display: !settingData.isMobile && 'none',
                        opacity: 0,
                        my: 3,
                        width: 0.4,
                    }} />

                <PageFooter pageId={pageId} />
            </Stack>
        </Stack>
    );
}

function NewsItem(props) {
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function tap() {
        navigate(`/newsDetail?id=${props.item.id}`,
            {
                state: {
                    x: ''
                }
            });
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                borderBottom: 1,
                borderColor: 'lightGray',
                width: settingData.isMobile ? 1 : '1150px',
                flexDirection: 'row',
                alignItems: 'center',
                cursor: 'pointer',
            }}>
            <Box
                component={'img'}
                src={getImgPath(props.item.image_url)}
                sx={{
                    height: settingData.isMobile ? '100px' : '150px',
                    objectFit: 'cover',
                    borderRadius: settingData.isMobile ? '4px' : '8px',
                    my: 2,
                    ml: 1.5,
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.03)',
                    }
                }} />

            {/* Mobile */}
            {settingData.isMobile &&
                <Stack sx={{ flex: 1 }}>
                    <Stack sx={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>

                        <Typography sx={{
                            fontFamily: 'Lexend Deca',
                            fontSize: 17,
                        }}>
                            {props.item.display_time}
                        </Typography>

                        <Box
                            component={'img'}
                            src={getImgPath('arrow_right.png')}
                            sx={{
                                height: '10px',
                                width: '10px',
                                borderRadius: '10px',
                                p: '5px',
                                objectFit: 'contain',
                                bgcolor: 'black',
                                ml: 3,
                            }} />
                    </Stack>

                    <Typography sx={{
                        fontFamily: 'Source Han Sans CN',
                        fontSize: 12,
                        fontWeight: 'bold',
                        flex: 1,
                        mt: 0.5,
                        ml: 2,
                        mr: 1,
                    }}>
                        {props.item.title}
                    </Typography>
                </Stack>}

            {/* PC */}
            {!settingData.isMobile &&
                <Stack sx={{
                    flexDirection: 'row',
                    width: 1,
                }}>
                    <Typography sx={{
                        fontFamily: 'Lexend Deca',
                        fontSize: 25,
                        mx: 5,
                    }}>
                        {props.item.display_time}
                    </Typography>

                    <Typography sx={{
                        fontFamily: 'Source Han Sans CN',
                        fontSize: 15,
                        fontWeight: 'bold',
                        flex: 1,
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.03)',
                        }
                    }}>
                        {props.item.title}
                    </Typography>

                    <Box
                        component={'img'}
                        src={getImgPath('arrow_right.png')}
                        sx={{
                            height: '16px',
                            width: '16px',
                            borderRadius: '16px',
                            p: '8px',
                            objectFit: 'contain',
                            bgcolor: 'black',
                            ml: 3,
                        }} />
                </Stack>}

        </Stack>
    )
}